export default __webpack_public_path__ + "static/media/Private_Equity_20230411.6e0857e6.pdf";